import { Injectable } from '@angular/core';
import { Http,Response , Headers } from '@angular/http';

import { Config } from '../../../config/config';
import { VnptHttpService } from '../../services/vnpt-http.service';
import { LichSuDangNhap } from './lich-su-dang-nhap';
@Injectable()
export class LichSuDangNhapService {

    controller:string = 'HT_LichSuDangNhap';
    constructor(private http: Http) { }

    GetMyLoginHistory(paging:number,maxSize:number,fromDate: string,toDate: string) {
        let headers = new Headers();
        let currentPage = paging - 1;
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller+'/GetHistory?offset='+currentPage+'&pageSize='+maxSize+'&fromDate='+fromDate+'&toDate='+toDate, { headers: headers }).map(resp => resp.json());
    }
    GetLoginHistoryCoQuan(paging:number,maxSize:number,fromDate: string,toDate: string,keyWord:string,idDonVi:number){
        let headers = new Headers();
        let currentPage = paging - 1;
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller+'/GetHistoryCoQuan?offset='+currentPage+'&pageSize='+maxSize+'&fromDate='+fromDate+'&toDate='+toDate+'&keyWord='+keyWord+'&idDonVi='+idDonVi, { headers: headers }).map(resp => resp.json());
    }
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/he-thong/lich-su-dang-nhap/lich-su-dang-nhap.service.ts